import React from 'react';
import { ROUTES } from 'constants/routes';
import { Routes, Route } from 'react-router-dom';
import Products from 'pages/Products';
import Resources from 'pages/Resources';
import MainLayout from 'Layout/main';
import AboutProducts from 'pages/AboutProduct';
import CropNutritionPrograms from 'pages/CropNutritionPrograms';
import TrialResults from 'pages/TrialResults';
import DetailedOfCropNutrition from 'pages/DetailedOfCropNutrition';
import DetailedTrialResults from 'pages/DetailedTrialResults';
import InformationMaterials from 'pages/InformationMaterials';
import AboutUs from 'pages/AboutUs';
import News from 'pages/News';
import Article from 'pages/Article';
import DetailedJob from 'pages/DetailedJob';
import Career from 'pages/Career';
import TermsAndConditions from 'pages/TermsAndConditions';
import LegalInfo from 'pages/LegalInfo';
import Contacts from 'pages/Contacts';
import Page404 from 'pages/Page404';
import { UIKit } from 'pages/UIKit/UIKit';
import { Homepage } from 'pages/Homepage/Homepage';
import { useDispatch, useSelector } from 'react-redux';
import { fetchHomepage } from 'store/slices/HomepageSlice';
import { fetchMainProducts } from 'store/slices/ProductsSlice';
import { fetchTranslations } from 'store/slices/GeneralTranslationsSlice';
import { selectActiveLanguageAndContry } from 'store/slices/languageSlice';
import { fetchLanguages, fetchCountries } from 'store/slices/languageSlice';

const App = () => {
    const dispatch = useDispatch();
    const { country, language } = useSelector(selectActiveLanguageAndContry);
    React.useEffect(() => {
        // @ts-ignore
        dispatch(fetchTranslations());
        // @ts-ignore
        dispatch(fetchHomepage());
        // @ts-ignore
        dispatch(fetchMainProducts());
        // @ts-ignore
        dispatch(fetchLanguages());
        // @ts-ignore
        dispatch(fetchCountries());
    }, [dispatch, country, language]);

    return (
        <>
            <Routes>
                <Route path="/ui-kit" element={<UIKit />} />
                <Route path={ROUTES.base} element={<MainLayout />}>
                    <Route path={ROUTES.base} element={<Homepage />} />
                    <Route path={ROUTES.products} element={<Products />} />
                    <Route path={ROUTES.products + '/:slug'} element={<AboutProducts />} />
                    <Route path={ROUTES.resources} element={<Resources />} />
                    <Route path={ROUTES.trialResults} element={<TrialResults />} />
                    <Route path={ROUTES.trialResults + '/:slug'} element={<DetailedTrialResults />} />
                    <Route path={ROUTES.cropNutritionPrograms} element={<CropNutritionPrograms />} />
                    <Route path={ROUTES.cropNutritionPrograms + '/:slug'} element={<DetailedOfCropNutrition />} />
                    <Route path={ROUTES.informationMaterials} element={<InformationMaterials />} />
                    <Route path={ROUTES.aboutUs} element={<AboutUs />} />
                    <Route path={ROUTES.news} element={<News />} />
                    <Route path={ROUTES.news + '/:slug'} element={<Article />} />
                    <Route path={ROUTES.article} element={<Article />} />
                    <Route path={ROUTES.career} element={<Career />} />
                    <Route path={ROUTES.career + '/:slug'} element={<DetailedJob />} />
                    <Route path={ROUTES.termsAndConditions} element={<TermsAndConditions />} />
                    <Route path={ROUTES.legalInfo} element={<LegalInfo />} />
                    <Route path={ROUTES.contacts} element={<Contacts />} />
                    <Route path="*" element={<Page404 />} />
                </Route>
            </Routes>
        </>
    );
};

export default App;
